<po-page-default [p-title]="page.title" [p-breadcrumb]="page.breadcrumb" [p-actions]="page.actions">

    <po-divider class="po-md-12" [p-label]="informacoesFornecedor"></po-divider>

    <div class="po-row">
        <div *ngFor="let d of arrHeaders">
            <po-input *ngIf="d.type == 'C' && !d.select && !d.f3" class="po-md-12" p-label="{{d.label}}" [p-disabled]="disabledField" p-required="{{d.required}}" p-readonly="{{d.readonly}}" [(ngModel)]="dados[d.property]" p-mask="{{d.format}}"></po-input>
            <po-select *ngIf="d.select" class="po-md-12" p-label="{{d.label}}" [p-disabled]="disabledFieldEdit" p-required="{{d.required}}" p-readonly="{{d.readonly}}" [p-options]="d.options" [(ngModel)]="dados[d.property]"></po-select>
            <po-datepicker *ngIf="d.type == 'D'" class="po-md-12" p-label="{{d.label}}" [p-disabled]="disabledFieldEdit" p-required="{{d.required}}" p-readonly="{{d.readonly}}" [(ngModel)]="dados[d.property]"></po-datepicker>
            <po-number *ngIf="d.type == 'N'" class="po-md-12" p-label="{{d.label}}" [p-disabled]="disabledFieldEdit" p-required="{{d.required}}" p-readonly="{{d.readonly}}" [(ngModel)]="dados[d.property]"></po-number>
            <po-textarea *ngIf="d.type == 'M'" class="po-md-12" p-label="{{d.label}}" [p-disabled]="disabledFieldEdit" p-required="{{d.required}}" p-readonly="{{d.readonly}}" [(ngModel)]="dados[d.property]"></po-textarea>
            <po-combo class="po-md-12" p-icon="po-icon po-icon-money" p-label="{{d.label}}" [p-options]="selects.condicaoPagamento" p-filter-mode="contains" [p-disabled]="disabledFieldEdit" p-required="{{d.required}}" [(ngModel)]="dados[d.property]" *ngIf="d.f3 && d.property == 'C8_COND'">
            </po-combo>
        </div>
    </div>

    <po-divider p-label="Itens da Cotação "></po-divider>

    <table class="table text-center po-table-main-container po-table">
        <thead>
            <tr>
                <th class="po-table-header">Proposta </th>
                <th class="po-table-header">Produto</th>
                <th class="po-table-header">Item Cotacao</th>
                <th class="po-table-header">U.M.</th>
                <th class="po-table-header">Quantidade</th>
                <th class="po-table-header">Preco Unitar</th>
                <th class="po-table-header">Total Item </th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of tableItens" class="altura-linha">
                <td style="font-weight: bold;" class="po-table-column po-table-striped">
                    <po-input class="po-lg-12" p-disabled="true" [(ngModel)]="item.C8_NUMPRO"></po-input>
                    <!-- <po-info class="po-lg-12" [p-value]="item.C8_NUMPRO"></po-info> -->
                </td>
                <td class="po-table-column po-table-striped">
                    <po-input class="po-lg-12" p-disabled="true" [(ngModel)]="item.C8_PRODUTO"></po-input>
                    <!-- <po-info style="font-weight: bold;" class="po-lg-12" [p-value]="item.C8_PRODUTO"> </po-info> -->
                </td>
                <td class="po-table-column po-table-striped">
                    <po-input class="po-lg-12" p-disabled="true" [(ngModel)]="item.C8_ITEM"></po-input>
                </td>
                <td class="po-table-column po-table-striped">
                    <po-input class="po-lg-12" p-disabled="true" [(ngModel)]="item.C8_UM"></po-input>
                </td>
                <td class="po-table-column po-table-striped">
                    <po-decimal class="po-lg-12" [p-disabled]="disabledFieldEdit" p-decimals-length="2" (p-change)="calculaPrecoAplicado(item)" [(ngModel)]="item.C8_QUANT"></po-decimal>
                </td>
                <td class="po-table-column po-table-striped">
                    <po-decimal class="po-lg-12" [p-disabled]="disabledFieldEdit" p-decimals-length="2" (p-change)="calculaPrecoAplicado(item)" [(ngModel)]="item.C8_PRECO"></po-decimal>
                </td>

                <td class="po-table-column po-table-striped">
                    <po-decimal class="po-lg-12" p-disabled="true" p-decimals-length="2" [(ngModel)]="item.C8_TOTAL"></po-decimal>
                </td>
            </tr>
        </tbody>
    </table>

    <po-loading-overlay *ngIf="loading" p-screen-lock="true" p-text="Carregando">
    </po-loading-overlay>
</po-page-default>